/**
 * Formats a date.
 * @param {Date} date
 * @param {string} format
 * @param {string} locale
 * @returns {string}
 */
export function formatDate(date, format, locale = getCurrentLocale()) {
    const map = {
        yyyy: date.getFullYear(),
        yy: String(date.getFullYear()).slice(-2),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        M: date.getMonth() + 1,
        dd: String(date.getDate()).padStart(2, '0'),
        d: date.getDate(),
        HH: String(date.getHours()).padStart(2, '0'),
        H: date.getHours(),
        mm: String(date.getMinutes()).padStart(2, '0'),
        m: date.getMinutes(),
        ss: String(date.getSeconds()).padStart(2, '0'),
        s: date.getSeconds(),
        EEEE: date.toLocaleDateString(locale, { weekday: 'long' }),
        EEE: date.toLocaleDateString(locale, { weekday: 'short' }),
        MMMM: date.toLocaleDateString(locale, { month: 'long' }),
        MMM: date.toLocaleDateString(locale, { month: 'short' }),
    };

    return format.replace(/yyyy|yy|MM|M|dd|d|HH|H|mm|m|ss|s|EEEE|EEE|MMMM|MMM/g, (match) => map[match]);
}

/**
 * Formats a date according to the Date strings format
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Date_and_time_formats#date_strings
 * @param date
 * @return {string}
 */
export function toDateStrings(date) {
    return formatDate(date, 'yyyy-MM-dd');
}

export function getCurrentLocale() {
    return document.documentElement.lang || 'de';
}

export function getRelativeTimeFormat(date, locale, style = 'long', numeric = 'always') {
    const currentDate = new Date();
    const minutes = Math.floor((currentDate - date) / 1000 / 60);
    let value;
    let unit;

    if (minutes <= 59) {
        value = -Math.round(minutes);
        unit = 'minute';
    } else if (minutes <= 1379) {
        value = -Math.round(minutes / 60);
        unit = 'hour';
    } else if (minutes <= 10079) {
        value = -Math.round(minutes / 60 / 24);
        unit = 'day';
    } else {
        value = -Math.round(minutes / 60 / 24 / 7);
        unit = 'week';
    }
    return new Intl.RelativeTimeFormat(locale, { numeric, style }).format(value, unit);
}
